import React, { useEffect } from 'react';
import I18n from 'i18n-js';
import { Icon, Spin } from 'grab-ui';
import _isEmpty from 'lodash/isEmpty';
import Storage from 'grab-storage';
import { isDev } from 'common/utils/environment-util';
import {
  APP_BASE_URL_PATH,
  STORAGE_USER_COUNTRY_CODE,
} from 'constants/app-constants';
import { setAuthHintCookie, clearLoginStorage } from 'helper/session-helper';
import { isUserAuthenticatedAsync } from 'helper/auth-helper';
import css from './gfb-login-success-redirect.less';

const GfbLoginSuccessRedirect = () => {
  useEffect(
    () => {
      if (_isEmpty(Storage.getItem(STORAGE_USER_COUNTRY_CODE))) {
        Storage.setItem(STORAGE_USER_COUNTRY_CODE, 'ID');
      }
      async function handleAuthentication() {
        clearLoginStorage();
        await isUserAuthenticatedAsync(true).then(isUserAuthenticated => {
          if (isUserAuthenticated) {
            setAuthHintCookie();
            setTimeout(() => {
              onClickRedirectToExpressHome();
            }, 200);
          } else {
            redirectToLoginPage();
          }
        });
      }

      handleAuthentication();
    },
    [isUserAuthenticatedAsync],
  );

  const onClickRedirectToExpressHome = () => {
    const { uri, endpoints: { expressHomeBaseUri } } = window.Grab.config;
    window.location.href = isDev()
      ? `${uri}${APP_BASE_URL_PATH}`
      : `${expressHomeBaseUri}${APP_BASE_URL_PATH}`;
  };

  const redirectToLoginPage = () => {
    const { endpoints: { expressHomeBaseUri } } = window.Grab.config;
    window.location.href = expressHomeBaseUri;
  };

  return (
    <div className={css.wrapper}>
      <div className={css.contentWrapper}>
        <img src={require('public/images/gfb-redirect.png')} alt="" />
        <div className={css.loadingWrapper}>
          <Spin
            indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
          />
          <div className={css.textWrapper}>
            <h4>{I18n.t('v2.redirectExpressPage.message')}</h4>
            <h6>
              {I18n.t('v2.redirectExpressPage.clickPrefix')}{' '}
              <span
                onClick={onClickRedirectToExpressHome}
                role="button"
                tabIndex="0"
                onKeyDown={null}
              >
                {I18n.t('v2.redirectExpressPage.click')}
              </span>
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GfbLoginSuccessRedirect;
